import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const useCopyToClipboard = () => {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const copy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            // Clear any pending timer, so a quick second copy is not cut
            // short by the first copy's timeout.
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setCopied(false), 1500);
        } catch (error) {
            // The copied values are always also visible on screen, so a
            // denied clipboard permission is not worth an error message.
        }
    };

    return [copied, copy];
};

const CopyButton = ({ text, label = 'Copy' }) => {
    const [copied, copy] = useCopyToClipboard();

    return (
        <Tooltip title={copied ? 'Copied!' : label}>
            <IconButton size="small" onClick={() => copy(text)} aria-label={label}>
                <ContentCopyIcon fontSize="inherit" />
            </IconButton>
        </Tooltip>
    );
};

export default CopyButton;
